import styled from 'styled-components'
import media from 'styled-media-query'

export const DefexMenuStyled = styled.aside`
	&& {
		margin-top: calc(56px + 2rem);

		${media.lessThan('medium')`
			margin-top: 0;
		`}
	}

	h4 {
		color: ${({ theme }) => theme.colors.text.light};
		font-size: 17px;
		font-weight: 300;
		margin: 0 0 0.5rem;
	}

	.category {
		margin: 0 0 1rem;

		.category-select {
			& > div {
				background: ${({ theme }) => theme.colors.main};
				border: 0;
				border-radius: 5px;
				box-shadow: none;
				color: ${({ theme }) => theme.colors.second};
				font-size: 14px;
				min-height: 35px;
				padding: 0;
				outline: none;
				
				& > div:first-child {
					& > div {
						color: ${({ theme }) => theme.colors.second};
					}
				}

				& > div:last-child {
					& > span {
						background: ${({ theme }) => theme.colors.second};
					}
					
					& > div {
						padding: 0.25rem;

						svg {
							fill: ${({ theme }) => theme.colors.second};
							stroke: ${({ theme }) => theme.colors.second};
						}
					}
				}
			}
		}			
	}
		
	// .selecteds {
	// 	ul {
	// 		display: flex;
	// 		flex-flow: wrap;
	// 		gap: 4px;
	// 		list-style: none;
	// 		padding: 5px 0 0;
	// 		margin: 0 0 1rem;
	// 		color: #fff;
	// 		overflow: auto;
	// 		overflow-x: hidden;
	// 		max-height: 124px;

	// 		li {
	// 			button {
	// 				padding: 0.25rem 0.25rem 0.25rem 0.25rem;
	// 				position: relative;

	// 				sup {
	// 					position: absolute;
	// 					top: -5px;
	// 					right: -4px;

	// 					svg {
	// 						background: ${({ theme }) => theme.colors.first};
	// 						color: ${({ theme }) => theme.colors.second};
	// 						border-radius: 50%;
	// 					}
	// 				}
	// 			}
	// 		}
	// 	}
	// }

	// .categories {
	// 	ul {
	// 		display: flex;
	// 		flex-flow: wrap;
	// 		gap: 4px;
	// 		list-style: none;
	// 		padding: 0;
	// 		margin: 0 0 1rem;
	// 		color: #fff;

	// 		li {
	// 			button {
	// 				&.disabled {
	// 					background: #ccc;
	// 					color: #666;
	// 				}
	// 			}
	// 		}
	// 	}
	// }
	
	& > button {
		${media.lessThan('medium')`
			width: 100%;
		`}
	}
`
